import type { ILiveStreamResponse } from '@/interface/ILiveStreamResponse';
import type { LiveStreamResponse } from '@/interface/pollux';

export function formatLiveStream(response: LiveStreamResponse): ILiveStreamResponse {
    return {
        url: response.url ?? '',
        errorCode: response.errorCode,
        errorMessage: response.errorMessage ?? '',
    };
}
